import * as React from 'react';

import PulsoidClient from '../../PulsoidClient';
import {CardGroup} from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import {resolveFeatureDescription, resolveIntegrationLogo} from './utils';
import {Action} from '../../system/buttons';
import {
  PulsoidBeatSaberModIntegrationCardFeatureDescription,
  PulsoidLivFeatureDescription,
  PulsoidLumiaFeatureDescription,
  PulsoidStreamDeckIntegrationCardFeatureDescription,
  PulsoidStromnoFeatureDescription,
  PulsoidVtsHeartRateFeatureDescription,
  PulsoidWindowsAppFeatureDescription,
  PulsoidAutomatedClipsCardFeatureDescription,
  PulsoidReportsCardFeatureDescription,
  PulsoidAitumCardFeatureDescription,
  PulsoiStreamerBotCardFeatureDescription,
  MagicChatboxFeatureDescription,
  OyasumiVRFeatureDescription,
  AiLiciaVRFeatureDescription,
  OverwolfFeatureDescription,
  TwitchIntegratedThrowingSystemFeatureDescription,
  VRCOSCFeatureDescription,
  RacelabFeatureDescription,
  SAMMIFeatureDescription,
  CrowdControlFeatureDescription,
} from '../../system/FeatureDescriptionModal';
import {groupByThree} from '../../system/utils';
import {generateRandomName} from '../../utils/generateRandomName';

export class Marketplace extends React.Component {
  constructor(props) {
    super(props);
    this.client = new PulsoidClient();
    this.state = {};
  }

  supportedWebHooks = [
    '13597a91-b45e-4105-a8ca-091e9c358dc9',
    '50b602a8-bb03-4929-8d2c-75986741fb62',
    'd0a08a5e-29f0-4f52-be45-8209ca36281e',
  ];

  resolveIntegration = (metaId, description) => {
    if (this.supportedWebHooks.includes(metaId)) {
      return (
        <Card
          style={{
            width: '18rem',
            height: '17rem',
            margin: '5px',
            border: '1px solid rgba(0,0,0,.125)',
          }}
          key={metaId}
          id={metaId}
          className="text-center"
        >
          {/*<Card.Header>{premium ? <>BRO plan 🌟 <PremiumFeatureDescription/></> : "Free"}</Card.Header>*/}
          <Card.Body style={{height: '100%', textAlign: 'center'}}>
            <Card.Title style={{height: '2rem'}}>
              {description}
              {resolveFeatureDescription(metaId)}
            </Card.Title>
            <div style={{height: '1rem'}} />
            <div style={{height: '8em'}}>{resolveIntegrationLogo(metaId)}</div>
            <Action onClick={this.handleAddNewWebHook(metaId)}>
              Add to my integrations
            </Action>
          </Card.Body>
        </Card>
      );
    } else {
      return null;
    }
  };

  emptyCard = (index) => {
    return (
      <Card
        style={{
          width: '18rem',
          height: '16rem',
          margin: '5px',
          border: '1px solid white',
        }}
        className="text-center"
        key={index}
      ></Card>
    );
  };

  handleAddNewWebHook = (metaId) => () => {
    this.client.addWebHook(generateRandomName(), metaId).then((z) => {
      this.props.onNewWebHook();
    });
  };

  componentDidMount() {
    this.client.getMetaWebHooks().then((metaWebHooks) =>
      this.setState({metaWebHooks}, () => {
        if (window.location.hash.includes('marketplace')) {
          document.getElementById('marketplace').scrollIntoView();
        }
      })
    );
  }

  render() {
    let integrations = [];
    if (this.state.metaWebHooks) {
      integrations = this.state.metaWebHooks
        .map((metaWebHook) =>
          this.resolveIntegration(metaWebHook.id, metaWebHook.description)
        )
        .filter((w) => w != null);
    }

    integrations.push(<LumiaIntegrationsCard key={integrations.length + 1} />);
    integrations.push(<StromoIntegrationCard key={integrations.length + 2} />);
    integrations.push(<LivIntegrationCard key={integrations.length + 3} />);
    // integrations.push(<WindowsAppIntegrationCard/>)
    integrations.push(
      <VtsHeartRateIntegrationCard key={integrations.length + 4} />
    );
    integrations.push(
      <StreamDeckIntegrationCard key={integrations.length + 5} />
    );
    // removed in scope of PLS-2133
    // integrations.push(
    //   <HRCounterForBeatSaberIntegrationCard key={integrations.length + 6} />
    // );
    integrations.push(
      <AutomatedClipsIntegrationCard key={integrations.length + 6} />
    );
    integrations.push(<ReportsIntegrationCard key={integrations.length + 6} />);
    integrations.push(<AitumIntegrationCard key={integrations.length + 6} />);
    integrations.push(<StreamerBot key={integrations.length + 6} />);
    integrations.push(<MagicChatbox key={integrations.length + 7} />);
    integrations.push(<OyasumiVR key={integrations.length + 8} />);
    integrations.push(<AiLicia key={integrations.length + 9} />);
    integrations.push(<Overwolf key={integrations.length + 10} />);
    integrations.push(<Tits key={integrations.length + 11} />);
    integrations.push(<VRCOSC key={integrations.length + 12} />);
    integrations.push(<Racelab key={integrations.length + 13} />);
    integrations.push(<SAMMI key={integrations.length + 14} />);
    integrations.push(<CrowdControl key={integrations.length + 16} />);
    integrations.push(this.emptyCard(integrations.length + 15)); // some strange beh.

    let grouped = groupByThree(integrations, (index) => this.emptyCard(index));

    return (
      <div id="marketplace">
        {this.state.metaWebHooks &&
          grouped.map((group, index) => (
            <CardGroup key={index}>{group}</CardGroup>
          ))}
      </div>
    );
  }
}

const integrationCard = (title, picture, feature) => (
  <Card
    style={{
      width: '18rem',
      height: '17rem',
      margin: '5px',
      border: '1px solid rgba(0,0,0,.125)',
    }}
    key={title}
    id={title}
    className="text-center"
  >
    <Card.Body style={{height: '100%', textAlign: 'center'}}>
      <Card.Title style={{height: '2rem'}}>{title}</Card.Title>
      <div style={{height: '1rem'}} />
      <div style={{height: '8em'}}>
        <img src={picture} style={{maxHeight: '80%'}} alt={'Loading...'} />
      </div>
      {feature}
    </Card.Body>
  </Card>
);

export const LumiaIntegrationsCard = () =>
  integrationCard(
    'Lumia Stream',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/lumia-stream.png',
    <PulsoidLumiaFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const StromoIntegrationCard = () =>
  integrationCard(
    'Stromno',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/stromno-integration-icon.png',
    <PulsoidStromnoFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const LivIntegrationCard = () =>
  integrationCard(
    'LIV',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/liv.png',
    <PulsoidLivFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const WindowsAppIntegrationCard = () =>
  integrationCard(
    'Windows Pulsoid App',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/windows-app.png',
    <PulsoidWindowsAppFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const VtsHeartRateIntegrationCard = () =>
  integrationCard(
    'VTube Studio plugin by Tom Farro',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/VTS-heartrate.png',
    <PulsoidVtsHeartRateFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const StreamDeckIntegrationCard = () =>
  integrationCard(
    'Stream Deck plugin',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/stream-deck.png',
    <PulsoidStreamDeckIntegrationCardFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const HRCounterForBeatSaberIntegrationCard = () =>
  integrationCard(
    'HRCounter for Beat Saber',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/hr-counter-bs.png',
    <PulsoidBeatSaberModIntegrationCardFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const AutomatedClipsIntegrationCard = () =>
  integrationCard(
    'Automated clips',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/automated-clips.png',
    <PulsoidAutomatedClipsCardFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const ReportsIntegrationCard = () =>
  integrationCard(
    'Reports',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/reports.png',
    <PulsoidReportsCardFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const AitumIntegrationCard = () =>
  integrationCard(
    'Aitum',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/aitum-logo.png',
    <PulsoidAitumCardFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const StreamerBot = () =>
  integrationCard(
    'Streamer.bot',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/streamerbot.png',
    <PulsoiStreamerBotCardFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const MagicChatbox = () =>
  integrationCard(
    'MagicChatbox',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/MagicChatbox.png',
    <MagicChatboxFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const OyasumiVR = () =>
  integrationCard(
    'OyasumiVR',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/OyasumiVR-logo.png',
    <OyasumiVRFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const AiLicia = () =>
  integrationCard(
    'ai_licia',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/ai_licia.png',
    <AiLiciaVRFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const Overwolf = () =>
  integrationCard(
    'Overwolf',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/overwolf-heart-rate-pulsoid-plugin.png',
    <OverwolfFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const Tits = () =>
  integrationCard(
    'Twitch Integrated Throwing System',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/Twitch-Integrated-Throwing-System-Pulsoid-Integration.png',
    <TwitchIntegratedThrowingSystemFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const VRCOSC = () =>
  integrationCard(
    'VRCOSC',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/VRCOSC-plugin-pulsoid.png',
    <VRCOSCFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const Racelab = () =>
  integrationCard(
    'Racelab',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/racelab.png',
    <RacelabFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const SAMMI = () =>
  integrationCard(
    'SAMMI',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/sammi.png',
    <SAMMIFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );

export const CrowdControl = () =>
  integrationCard(
    'Crowd Control',
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/crowd-control-logo.png',
    <CrowdControlFeatureDescription
      component={(toggle) => <Action onClick={toggle}>Read more</Action>}
    />
  );
